<template>
  <div class="query">
    <z-title title="预定查询"></z-title>
    <el-card class="top-content">
      <div class="flex-n fac fjb">
        <el-button type="primary" class="ele-btn1" @click="addReserve">新增预定</el-button>
        <div class="flex-n fac">
          <el-radio-group v-model="timeType" size="mini" class="flex-n" @change="changeTimeType(today)">
            <el-radio-button label="0">日</el-radio-button>
            <el-radio-button label="1">周</el-radio-button>
          </el-radio-group>
          <div class="flex-n fac fjc  tmid">
            <i class="icon el-icon-caret-left" v-pointer @click="before"></i>
            <div class="text textnowrap">
              <el-date-picker
                v-model="beginDate"
                align="right"
                size="mini"
                prefix-icon="none"
                type="date"
                class="w-160"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                :clearable="false"
                :picker-options="{
                    disabledDate:(date)=>{return timeType==1?(date.getDay()!==1):false}
                  }"
                @change="changeBeginDate"
                placeholder="选择日期">
              </el-date-picker>
              <template v-if="endDate">
                -
                <el-date-picker
                  v-model="endDate"
                  align="right"
                  size="mini"
                  prefix-icon="none"
                  type="date"
                  :clearable="false"
                  class="w-160"
                  :picker-options="{
                    disabledDate:(date)=>{return date.getDay()!==0}
                  }"
                  format="yyyy年MM月dd日"
                  value-format="yyyy-MM-dd"
                  @change="changeEndDate"
                  placeholder="选择日期">
                </el-date-picker>
              </template>
              <!--              {{$TM.setTextData(beginDate)}}{{endDate?(' - '+$TM.setTextData(endDate)):''}}-->
            </div>
            <i class="icon el-icon-caret-right" v-pointer @click="after"></i>
          </div>
          <el-button type="primary" size="mini" @click="changeTimeType(today)">{{ timeType == '1' ? '本周' : '今天' }}
          </el-button>
        </div>
        <div class="flex-n fac right">
          <div class="flex-n fac textnowrap">
            <div class="square1"></div>
            <div>已定</div>
          </div>
          <div class="flex-n fac textnowrap">
            <div class="square2"></div>
            <div>预留</div>
          </div>
          <div class="flex-n fac textnowrap">
            <div class="square3"></div>
            <div>免费</div>
          </div>
        </div>
        <div class="daytype flex-n fac">
          <el-checkbox style="margin-right: 10px" v-model="checkAll" @change="handleCheckAllChange">全选
          </el-checkbox>
          <el-checkbox-group v-model="checkedList" @change="handleCheckedCitiesChange">
            <el-checkbox style="margin-right: 10px;" v-for="(item,index) in houseTypeList"
                         :label="item.houseTypeId" :key="item.houseTypeId">{{ item.houseTypeName }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </el-card>
    <day-query v-show="timeType=='0'" class="mt-10" ref="day" @chooseDate="(date)=>changeTimeType(date)"
               @copyInfo="copyInfo"
               @beforeMonth="beforeMonth" @nowMonth="nowMonth" @afterMonth="afterMonth"></day-query>
    <week-query v-show="timeType=='1'" class="mt-10" ref="week" @chooseDate="(date)=>changeTimeType(date)"
                @copyInfo="copyInfo"></week-query>
    <!--新增预定-->
    <books ref="newbook" :visible.sync="booksDialog" @refresh="(date)=>changeTimeType(date)"></books>
  </div>
</template>

<script>

  import ZTitle from "../../components/ZTitle";
  import DayQuery from "./sub/DayQuery";
  import WeekQuery from "./sub/WeekQuery";
  import Books from "../component/books";

  export default {
    components: {
      Books,
      WeekQuery,
      DayQuery,
      ZTitle

    },
    name: "query",
    data() {
      return {
        timeType: '0',
        beginDate: '',
        endDate: '',
        today: '',
        booksDialog: false,
        checkAll: false,
        checkedList: [],
        houseTypeList: [],

        timeTagList:[],
        tagList:[]
      }
    },
    mounted() {
      this.today = this.$TM.getDayArea().date;
      this.gethouseTypeList();
      this.getTimeRange();
    },
    methods: {
      getTimeRange() {
        this.$axios.get('/config/baseByStoreId/' + this.$root.getStorage('storeId')).then(res => {
          console.log('基本店铺设置信息', res.data)
          let orderTag = [];
          for (let i in res.data.orderTag) {
            orderTag.push(res.data.orderTag[i].beginTime + '~' + res.data.orderTag[i].endTime)
          }
          this.timeTagList = orderTag;
          this.tagList = res.data.orderTag;
        }).catch(err => {
          this.$message.error(err.msg);
        })
      },
      //新增预订
      addReserve() {
        let date = '';
        if (this.timeType == '0') {//日
          date = this.beginDate;
        } else {
          if (new Date(this.today) >= new Date(this.beginDate) && new Date(this.today) <= new Date(this.endDate)) {
            date = this.today;
          } else {
            date = this.beginDate;
          }
        }
        console.log(date)
        this.$nextTick(() => {
          this.$refs.newbook.dataForm.orderDate = date;
          this.booksDialog = true;
        })
      },
      //todo 场地类型
      gethouseTypeList() {
        this.$axios.get("/house/houseTypeListByStoreId/" + this.$root.getStorage('storeId')).then(res => {
          console.log('场地类型', res)
          this.houseTypeList = res.data.list;
          if (this.$root.getStorage('checkedCities')) {
            this.checkedList = this.$root.getStorage('checkedCities');
          }
          this.changeTimeType(this.today);
        }).catch(err => {
          this.$message.error(err.msg);
        })
      },
      handleCheckAllChange(val) {
        console.log(val)
        var checkedList = [];
        if (val) {
          for (var i in this.houseTypeList) {
            checkedList.push(this.houseTypeList[i].houseTypeId)
          }
        }
        this.checkedList = checkedList;
        if (this.timeType == '0') {//日
          this.$nextTick(() => {
            if (this.$refs.day)
              this.$refs.day.gethouseList(checkedList);
          })
        } else {
          this.$nextTick(() => {
            if (this.$refs.week)
              this.$refs.week.getCalendar(this.beginDate, this.endDate, checkedList);
          })
        }
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        console.log(value)
        this.checkAll = checkedCount == this.houseTypeList.length ? true : false;
        this.checkedList = value;
        this.$root.setStorage('checkedCities', value);
        if (this.timeType == '0') {//日
          this.$nextTick(() => {
            if (this.$refs.day) {
              this.$refs.day.getCalendar(this.beginDate, value);
              this.$refs.day.gethouseList(value);
            }
          })
        } else {
          this.$nextTick(() => {
            if (this.$refs.week)
              this.$refs.week.getCalendar(this.beginDate, this.endDate, value);
          })
        }
      },
      //todo 选择展示方式
      changeTimeType(day) {
        console.log('日期', day)
        if (this.timeType == '0') {//日
          this.beginDate = this.$TM.getDate(new Date(day).getTime());
          this.endDate = '';
        } else {//周
          console.log(this.$TM.getDayArea())
          let xx = new Date(day).getDay();
          if (xx == 0) {
            xx = 7
          }
          this.beginDate = this.$TM.getDate(new Date(day).getTime() - (xx - 1) * 24 * 60 * 60 * 1000);
          this.endDate = this.$TM.getDate(new Date(day).getTime() + (7 - xx) * 24 * 60 * 60 * 1000);
        }
        this.getDataList();
      },
      getDataList() {
        let checkedList = this.checkedList || [];
        if (checkedList.length == 0) {
          let houseTypeList = [];
          for (var i in this.houseTypeList) {
            houseTypeList.push(this.houseTypeList[i].houseTypeId)
          }
          checkedList = houseTypeList;
        }

        if (this.timeType == '0') {//日
          this.$nextTick(() => {
            if (this.$refs.day)
              this.$refs.day.getCalendar(this.beginDate, checkedList);
          })
        } else {
          console.log('开始时间', this.beginDate, '结束时间', this.endDate)
          this.$nextTick(() => {
            if (this.$refs.week)
              this.$refs.week.getCalendar(this.beginDate, this.endDate, checkedList);
          })
        }
      },
      //todo 选择天
      changeBeginDate(beginDate) {
        console.log(beginDate)
        if (this.timeType == '1') {
          this.endDate = this.$TM.getDate(new Date(beginDate).getTime() + 6 * 24 * 60 * 60 * 1000);
        }
        this.getDataList();
      },
      changeEndDate(endDate) {
        if (this.timeType == '1') {
          this.beginDate = this.$TM.getDate(new Date(endDate).getTime() - 6 * 24 * 60 * 60 * 1000);
        }
        this.getDataList();
      },
      //上一个月
      beforeMonth() {
        let beginDate = this.beginDate;
        let year = Number(beginDate.substring(0, 4)), month = Number(beginDate.substring(5, 7));
        month--;
        if (month == 0) {
          year--;
          month = 12;
        }
        this.beginDate = year + '-' + (month > 9 ? month : ('0' + month)) + '-01';
        console.log(this.beginDate)
        this.getDataList();
      },
      //
      nowMonth() {
        this.beginDate = this.$TM.getDate(new Date().getTime());
        this.getDataList();
      },
      //下一个月
      afterMonth() {
        let beginDate = this.beginDate;
        let year = Number(beginDate.substring(0, 4)), month = Number(beginDate.substring(5, 7));
        month++;
        if (month == 13) {
          year++;
          month = 1;
        }
        this.beginDate = year + '-' + (month > 9 ? month : ('0' + month)) + '-01';
        console.log(this.beginDate)
        this.getDataList();
      },
      //todo 前一天
      before() {
        let beginDate = this.beginDate;
        if (this.timeType == '0') {//日
          this.beginDate = this.$TM.getDate(new Date(beginDate).getTime() - 24 * 60 * 60 * 1000);
          this.endDate = '';
        } else {//周
          beginDate = new Date(beginDate).getTime() - 7 * 24 * 60 * 60 * 1000
          this.beginDate = this.$TM.getDate(beginDate - (new Date(beginDate).getDay() - 1) * 24 * 60 * 60 * 1000);
          this.endDate = this.$TM.getDate(beginDate + (7 - new Date(beginDate).getDay()) * 24 * 60 * 60 * 1000);
        }
        this.getDataList();
      },
      //todo 后一天
      after() {
        let beginDate = this.beginDate;
        if (this.timeType == '0') {//日
          this.beginDate = this.$TM.getDate(new Date(beginDate).getTime() + 24 * 60 * 60 * 1000);
          this.endDate = '';
        } else {
          beginDate = new Date(beginDate).getTime() + 7 * 24 * 60 * 60 * 1000
          this.beginDate = this.$TM.getDate(beginDate - (new Date(beginDate).getDay() - 1) * 24 * 60 * 60 * 1000);
          this.endDate = this.$TM.getDate(beginDate + (7 - new Date(beginDate).getDay()) * 24 * 60 * 60 * 1000);
        }
        this.getDataList();
      },

      //todo 复制信息
      copyInfo(id) {
        this.$axios.get('/order/orderDetailById/' + id).then(res => {
          var info = res.data;
          var content = '';
          var packageContent = '', orderExtraContent = '', payContent = '';
          //套餐文字
          for (var i in info.orderPackage.itemsExs) {
            packageContent += info.orderPackage.itemsExs[i].itemName + '、';
          }
          for (var i in info.orderPackage.itemsFoods) {
            packageContent += info.orderPackage.itemsFoods[i].foodName + '、';
          }
          if (packageContent.substring(packageContent.length - 1, packageContent.length) == '、') {
            info.packageContent = packageContent.substring(0, packageContent.length - 1)
          }
          //额外项目文字
          for (var i in info.orderExtra.itemsExs) {
            orderExtraContent += info.orderExtra.itemsExs[i].itemName + ':' + info.orderExtra.itemsExs[i].itemPrice + '*' + info.orderExtra.itemsExs[i].itemCount + '、';
          }
          for (var i in info.orderExtra.itemsFoods) {
            orderExtraContent += info.orderExtra.itemsFoods[i].foodName + ':' + info.orderExtra.itemsFoods[i].foodPrice + '*' + info.orderExtra.itemsFoods[i].foodCount + '、';
          }
          if (orderExtraContent.substring(orderExtraContent.length - 1, orderExtraContent.length) == '、') {
            info.orderExtraContent = orderExtraContent.substring(0, orderExtraContent.length - 1)
          }
          var payTypes = info.payTypes;
          payTypes.sort((a, b) => {
            return Number(b.payTypeCode) - Number(a.payTypeCode);
          })
          for (var i in payTypes) {
            if (payTypes[i].payTypeCode == '03') {
              payContent += '包场费用：' + (payTypes[i].housePrice || 0) + '\n';
            }
            if (payTypes[i].payTypeCode == '02') {
              payContent += '预定桌数：' + (payTypes[i].orderCount || 0) + '\n';
              payContent += '每桌单价：' + (payTypes[i].onePrice || 0) + '\n';
            }
            if (payTypes[i].payTypeCode == '01') {
              payContent += '预定人数：' + (payTypes[i].orderCount || 0) + '\n';
              payContent += '每人单价：' + (payTypes[i].onePrice || 0) + '\n';
            }
          }

          let activityBeginTime = this.getFormatTimeText(info.activityBeginTime);
          let activityEndTime = this.getFormatTimeText(info.activityEndTime);
          let idx = this.timeTagList.indexOf(info.activityBeginTime + '~' + info.activityEndTime);
          // let labelText = idx > -1 ? this.tagList[idx].tagName :(activityBeginTime+'~'+activityEndTime);
          let labelText = activityBeginTime+'~'+activityEndTime;//2022-05-04宋哥要求显示时间段 不用改成标签

          //复制未处理
          content = this.$store.state.storeName + '预定单' + '\n' +
            '客户名称：' + info.customName + '\n' +
            '客户电话：' + (info.phone || '无') + '\n' +
            '订单日期：' + info.orderDate + '\n' +
            '预定时段：' + labelText + '\n' +//2022-05-04宋哥要求显示时间段 不用改成标签
            '预定场地：' + info.houseName + '\n' +
            (info.packageName ? ('套餐名称：' + info.packageName + '\n' +
              (info.packageContent ? ('           （' + info.packageContent + '）\n') : '')) : '') +
            payContent +
            (orderExtraContent.length > 0 ? ('增加项目：' + info.extraRealMoney + '\n') : '') +
            (info.orderExtraContent ? '           （' + info.orderExtraContent + '）\n' : '') +
            '已交订金：' + info.downPayment + '\n' +
            '下单日期：' + info.createTime.substring(5,16) + '\n' +  //2022-05-04宋哥要求改成月日时分格式
            '接待人员：' + info.createUserName + '\n' +
            (info.createUserPhone ? ('接待电话：' + info.createUserPhone + '\n') : '') +
            '订单备注：' + (info.remark ? info.remark : '无') + '\n';
          console.log(content)
          this.$copyText(content).then((e) => {
            this.$message.success('已复制到剪贴板');
            console.log(e)
          }, (err) => {
            this.$message.success('复制失败');
            console.log(err)
          })
        }).catch(err => {
          this.$message.error(err.msg);
        })
      },
      getFormatTimeText(time) {
        let ytime = Number(time.replace(':', ''));
        var c1 = Number(ytime / 100).toFixed(0)
        c1 = c1 < 10 ? ('0' + c1) : (c1 > 23 ? ('次日' + ((c1 - 24) > 9 ? (c1 - 24) : ('0' + (c1 - 24)))) : c1);
        c1 = c1 + ':' + (ytime % 100 ? '30' : '00')
        return c1;
      },
    }
  }
</script>

<style scoped lang="scss">
  .square1 {
    background: #D0E5FF;
  }

  .square2 {
    background: #D8C9FC;
  }

  .square3 {
    background: #e6e6e6;
  }

  .top-content {
    position: relative;

    .daytype {
      position: absolute;
      bottom: 2px;
      left: 150px;
    }

    .right {
      font-size: 14px;

      div[class^='square'] {
        width: 15px;
        height: 15px;
        margin-right: 5px;
        margin-left: 15px;
      }
    }

    .tmid {
      flex: 1;
      padding: 0 20px;

      .text {
        flex: 1;
        font-size: 13px;
        text-align: center;
      }

      .icon {
        padding: 0 10px;
        font-size: 36px;
      }
    }
  }
</style>
